import { Link } from "react-router-dom";
import { ArrowRight } from "lucide-react";
import { FadeIn } from "../FadeIn";
import { MagneticButton } from "../MagneticButton";

export const CtaSection = () => (
  <section data-testid="cta-section" className="bg-ink py-32">
    <div className="container-x text-center">
      <FadeIn>
        <div className="eyebrow mb-6">Prêt à partir</div>
        <h2 className="font-display text-5xl md:text-8xl mb-10 max-w-4xl mx-auto leading-[0.95]">
          Documentons votre prochaine{" "}
          <span className="italic text-stone">expédition</span>.
        </h2>
        <Link to="/contact" data-testid="cta-contact">
          <MagneticButton className="btn-line" as="span">
            <span>Prendre contact</span>
            <ArrowRight size={14} />
          </MagneticButton>
        </Link>
      </FadeIn>
    </div>
  </section>
);
